var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.1001 18.9H9.0001V12.9375H15.0001V18.9H17.9001V10.025L12.0001 5.6L6.1001 10.025V18.9ZM4.2251 20.775V9.0875L12.0001 3.25L19.7751 9.09167V20.775H13.1251V14.8125H10.8751V20.775H4.2251Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.b93a35cbbf06555201b591e56ab78e17.svg";
export { ForwardRef as ReactComponent };